import React, { Component, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link,Badge,FormHelperText,Checkbox,Switch, Select,MenuItem,ListItemText, InputLabel, Box, FormControl,OutlinedInput, Container, Grid, Card, CardContent, CardHeader, Divider, Typography, Icon, LinearProgress, linearProgressClasses, CardActions, Button, Chip, CircularProgress, TextField , Radio, Dialog, DialogTitle, CardActionArea} from '@mui/material';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart'
import { Modal } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash'
import FormLabel from '@mui/material/FormLabel'
import { _freedomAxios,_axios, _hrwinStageAxios, _opsToolAxios } from 'src/plugins/axios';
import { Notify } from 'src/components/common/Notify';
import { styled } from '@mui/material/styles';

export default function WalletConfiguration () {

    const res = {
        "success": true,
        "data": []
    }
    let enttiyIDFromSession = sessionStorage.getItem('entityId');
    const [entityId, setEntityId] = React.useState(enttiyIDFromSession);
    const [config, setConfig]  = React.useState(false);
    const [walletConfig, setWalletConfig] = React.useState([]);
    const [entityRelationList,setEntityRelationList]  = React.useState([]);
    const [walletContracts,setWalletContracts] = React.useState({ 'CorpWallet' : [], 'MBWallet' : [], "MAWallet" : [] });
    const [ activeStatus, setActiveStatus ] = React.useState( { 'CorpWallet' : false, 'MBWallet' : false, 'MAWallet' : false });
    const [configStatus, setConfigStatus ] = React.useState(false);
    const totalWallets = ['CorpWallet', 'MBWallet', 'MAWallet' ];
    const RelationList = ['Mother','Self',
        'Brother',
        'Daughter',
        'Father',
        'Sister',
        'Son',
        'Father-in-law',
        'Mother-in-law',
        'Spouse',
        'Others']

    const [coPayWallet, setCopayWallet] = React.useState('');
    const [coPayService, setCoPayService] = React.useState('');
    const [coPayGrade, setCoPayGrade]  = React.useState('');
    const [coPayAllowedRelations, setCoPayAllowedRelations] = React.useState([]);
    const [coPayLimit,setCopayLimit ] = React.useState(0);
    const [blockLimit, setBlockLimit] = React.useState(0);
    const [groupService, setGroupService ] = React.useState([]);
    
    const  walletConfigOnContract = () => {

        let payLoad = {}
        payLoad.wr_wallet = coPayWallet
        payLoad.wr_service = coPayService
        payLoad.wr_relation = coPayAllowedRelations.join();
        payLoad.wr_grade = coPayGrade;
        payLoad.wr_copay = coPayLimit
        payLoad.wr_blocklimit = blockLimit ? blockLimit : null
        payLoad.wr_groupService = groupService ? groupService.join() : groupService;
        payLoad.passkey = "Medibuddy",
        _opsToolAxios
        .post('tech/addWalletRule', payLoad)
        .then((response) => {

            if(response.data.success){
                return alert("wallet Rule Configuration success")
            }
            alert("wallet Rule Configuration failed")
        })
        .catch((error) => {
            alert("wallet Rule Configuration failed")
        })
    }

    const CopayComponent = () => {
            return (
                <div>
                <Typography variant="h3" component="h3">Wallet Rules Configuration</Typography>
                <FormControl sx = {{m:2 , minWidth : '200px' }}>
                <InputLabel id="demo-simple-select-autowidth-label">Wallet</InputLabel>
                <Select value = {coPayWallet} sx = {{minWidth: '100px'}}
                    onChange = {(e) => {
                        setCopayWallet(e.target.value);
                        
                    }} 
                    label = "wallet Name">
                        {totalWallets.map((val, index) => (
                            <MenuItem sx = {{py:0}} key={index} value = {val}>
                            <ListItemText primary={val} />
                            </MenuItem>
                        ))}
                </Select>
                </FormControl>
                <FormControl  variant="outlined" sx = {{m:2 , minWidth : '200px' }}>
                <InputLabel id="contract-select">Contract</InputLabel>
                <Select
                  value={coPayService}
                  onChange={(e) => setCoPayService(e.target.value)}
                  label="Contract"
                >
                  {entityRelationList.map(
                      (val, idx) => (
                        <MenuItem sx = {{py:0}} key={val.Id} value = {val.Id}>
                        <ListItemText primary={val.entity} />
                        </MenuItem> )     
                      )}
                  
                </Select>
              </FormControl>    
            <TextField sx = {{margin : '2%'}}
                id="outlined"
                label = "Grade "
                defaultValue= {coPayGrade}
                onChange = {(e) => setCoPayGrade(e.target.value)}
            />
             

            <FormControl  variant="outlined" sx = {{m:2 , minWidth : '200px' }}>
                <InputLabel id="contract-select">Allowed Relations</InputLabel>
                <Select
                  multiple
                  value={coPayAllowedRelations}
                  onChange={(e) => {setCoPayAllowedRelations(e.target.value)}}
                  renderValue={(selected) => selected.join(', ')}
                  label="AllowedRelations"
                >
                  {RelationList.map(
                      (val, idx) => (
                        <MenuItem sx = {{py:0}} key={idx} value = {val}>
                        <Checkbox checked={  coPayAllowedRelations.length && coPayAllowedRelations.indexOf(val) > -1 ? true : false} />
                        <ListItemText primary={val} />
                        </MenuItem> )     
                      )}
                  
                </Select>
            </FormControl>    
            <TextField sx = {{margin : '2%'}}
                type="number"
                id="outlined"
                label = "co-PayLimit Percentage"
                defaultValue= {coPayLimit}
                InputProps={{ inputProps: { min: 0, max: 100 } }}
                onChange = {(e) => setCopayLimit(e.target.value)}
            />
            <TextField sx = {{margin : '2%'}}
                type="number"
                id="outlined"
                label = "Block Limit "
                defaultValue= {blockLimit}m
                 InputProps={{ inputProps: { min: 0}}}
                onChange = {(e) => setBlockLimit(e.target.value)}
            />
            <FormControl  variant="outlined" sx = {{m:2 , minWidth : '200px' }}>
                <InputLabel id="contract-select">Group Service</InputLabel>
                <Select
                  multiple
                  value={groupService}
                  onChange={(e) => setGroupService(e.target.value)}
                  renderValue={(selected) => selected.join(', ')}
                  label="Location"
                >
                  {entityRelationList.map(
                      (val, idx) => (
                        <MenuItem sx = {{py:0}} key={val.Id} value = {val.Id}>
                        <Checkbox checked={groupService.length && groupService.indexOf(val.Id) > -1 ? true : false} />
                        <ListItemText primary={val.entity} />
                        </MenuItem> )     
                      )}
                  
                </Select>
              </FormControl> 
              <Button variant="contained" sx = {{m: 2}}
                                            onClick = {(e) =>  walletConfigOnContract()}
                                        >
                                            Create Wallet Rules
              </Button>
            {/* <TextField sx = {{margin : '2%'}}
                id="outlined"
                label = "Group Service "
                defaultValue= {groupService}
                onChange = {(e) => setGroupService(e.target.value)}
            /> */}
            </div>
            )
    } 

    const handleChange = (contract, walletName) => {
        let addition = { [walletName] : [ ...contract]}
        let finalValue  = {...walletContracts, ...addition}
        setWalletContracts(finalValue);
      };

    const entityRelationListInfo = () => {
        let list = [], listArray = {};
        const body = {
            lookUp: "EntityRelation"
        };
        _freedomAxios.post('corporate/lookup', body)
        .then(response => {
            if(response.data.isSuccess){
    
                let list = JSON.parse(response.data.result);
                setEntityRelationList(list);
            }
        }).catch(error => {
            if(error.response && error.response.data)
                alert(error.response.data.message);
        })
    }

    const walletInfo = () => {
        /* remove above part */
        _opsToolAxios
        .get(`/tech/getCorporateWalletDetails/${entityId}`)
        .then((response) => {
            if(response.data.success){
                setConfig(true);
                setWalletConfig(response.data.data);
                console.log('res.d', response.data.data);
                let activeWallet ={CorpWallet: false, MBWallet: false, MAWallet: false}
                response.data.data.map((val, index) => {
                    let contract = val.CWC_ELIGIBLECONTRACTS.split(',').map(Number);
                    activeWallet[val.CWC_WALLETNAME]=val.CWC_ISACTIVE
                    console.log( "wallet Configuration" , { ...walletContracts, ...contract});
                    setWalletContracts({ ...walletContracts, ...contract});
                })
                setActiveStatus(activeWallet)
            }
        })
        .catch((error) => {

        })
    }

    const walletConfiguration = ({entityId, walletName}) => {
        let payLoad = {};
        payLoad.pmEntityId = Number(entityId),
        payLoad.servicesList = walletContracts[walletName].join();
        payLoad.isInactivate = Number(!activeStatus[walletName]);
        payLoad.passkey = "MediBuddy",
        payLoad.walletName = walletName
        _opsToolAxios
        .post('tech/walletconfiguration', payLoad)
        .then((response) => {
            let resp = response.data;
            if(resp.respData.status == 200){
                setConfigStatus(true);
                alert("wallet Configuration success")
            }
        })
        .catch((error) => {
            alert("error in creation of Wallet Configuration");
        })
    }

    const Wallet = ({walletName, config, active}) => {
        return (
            <CardContent>
              <TextField sx = {{margin : '1%'}}
                disabled
                id="outlined-disabled"
                label = "Wallet "
                defaultValue= {walletName}
                
            />
            <FormControl  variant="outlined" sx = {{m:2 , minWidth : '200px' }}>
                <InputLabel id="contract-select">Contract</InputLabel>
                <Select
                  multiple
                  value={walletContracts[walletName]}
                  onChange={(e) => handleChange(e.target.value, walletName)}
                  renderValue={(selected) => selected.join(', ')}
                  label="Location"
                >
                  {entityRelationList.map(
                      (val, idx) => (
                        <MenuItem sx = {{py:0}} key={val.Id} value = {val.Id}>
                        <Checkbox checked={walletContracts[walletName].length && walletContracts[walletName].indexOf(val.Id) > -1 ? true : false} />
                        <ListItemText primary={val.entity} />
                        </MenuItem> )     
                      )}
                  
                </Select>
              </FormControl>   

            <Checkbox
            sx={{ m: 1, marginLeft: 3 }} 
            checked = {activeStatus[walletName]}
            inputProps={{ 'aria-label': 'controlled' }}
            color="secondary"
            onClick={(e) => {
                setActiveStatus({ ...activeStatus, [walletName] : e.target.checked } )
            }
            } 
            />
            <Button variant="contained" sx = {{m: 2}}
                                            onClick = {(e) =>  walletConfiguration({entityId, walletName})}
                                        >
                                        configure
            </Button>
            
        </CardContent>);
    }


    useEffect(() => {
        entityRelationListInfo();
        setWalletConfig(res.data);
            res.data.map((val, index) => {
                
                let contract = val.CWC_ELIGIBLECONTRACTS.split(',').map(Number);
                let config = { [val.CWC_WALLETNAME] : contract}
                setWalletContracts( { ...walletContracts, ...config});
            })
        
    }, []);

    useEffect( () => {
        console.log("useEffects logging",walletContracts);
    }, [walletContracts]);
    

    return (
        <Card>
            <CardContent>
              <TextField sx = {{margin : '1%'}}
                id="outlined-disabled"
                label = "EntityId "
                defaultValue= {entityId}
                onChange = {(e) => setEntityId(e.target.value)}
            />
            { !config && <Button variant="contained" sx = {{m: 1}}
                                onClick = {(e) =>  walletInfo(entityId)}
                             >
                                Get WALLET INFORMATION
                            </Button> }
                <Grid>
                    <Grid item key = {19000}>
                        {totalWallets.map((val,index) => {
                            
                            const indexPos = Object.keys(walletConfig).find((index) => walletConfig[index].CWC_WALLETNAME);
                            console.log(indexPos);
                            return (<Wallet walletName = {indexPos && indexPos.CWC_WALLETNAME ? indexPos.CWC_WALLETNAME : val} config = {indexPos && indexPos.CWC_ELIGIBLECONTRACTS ? indexPos.CWC_ELIGIBLECONTRACTS : []} active = {indexPos && indexPos.CWC_ISACTIVE ? indexPos.CWC_ISACTIVE : false} />)
                        }) }
                        {/* {walletConfig.map((val, index) => <Wallet walletName = {val.CWC_WALLETNAME} config = {val.CWC_ELIGIBLECONTRACTS} active = {val.CWC_ISACTIVE} />)} */}
                    </Grid>
                </Grid>
                {configStatus && <Button variant="contained" sx = {{m: 1}}
                                onClick = {(e) =>  walletInfo(entityId)}
                             >
                                Get WALLET INFORMATION
                            </Button>}
                
            </CardContent>
            <CardContent>
                <CopayComponent />
            </CardContent>
        </Card>
    )

}
